import { IMenuItem } from "./navigation.model";



export let companyMenu: IMenuItem[] = [
  {
    name: "DASHBOARD",
    type: "link",
    tooltip: "Dashboard",
    state: "company/dashboard"
  },
  {
    name: "Customers",
    type: "link",
    tooltip: "Members",
    state: "company/customer",
    sub: [
      { name: "Member", type: 'link', state: "company/members/view" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },
  {
    name: "Employees",
    type: "link",
    tooltip: "Employees",
    state: "company/employee",
    sub: [
      { name: "Employee", type: 'link', state: "company/employee/view" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },
  {
    name: "Campaigns",
    type: "link",
    tooltip: "Trainer",
    state: "company/campaigns",
    sub: [
      { name: "Trainer", type: 'link', state: "company/trainers/view" },
      { name: "Trainer", type: 'link', state: "company/trainers/edit" },
      { name: "Trainer", type: 'link', state: "company/trainers/create" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },

  {
    name: "Reports",
    type: "link",
    tooltip: "Doctor",
    state: "company/reports",

    badges: [{ color: "primary", value: "1" }]
  },


  {
    name: "Settings",
    type: "link",
    state: "company/settings/change-password",

  },

]

export let arcMenu: IMenuItem[] = [
  {
    module:['dashboard'],
    name: "DASHBOARD",
    type: "link",
    tooltip: "Dashboard",
    state: "dashboard"
  },
  {
    module:['customer'],
    name: "Customers",
    type: "link",
    tooltip: "Members",
    state: "customer",
    sub: [
      { name: "Member", type: 'link', state: "members/view" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },
  {
    module:['employee'],
    name: "Employees",
    type: "link",
    tooltip: "Employees",
    state: "employee",
    sub: [
      { name: "Employee", type: 'link', state: "employee/view" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },
  {
    module:['campaign'],
    name: "Campaigns",
    type: "link",
    tooltip: "Trainer",
    state: "campaigns",
    sub: [
      { name: "Trainer", type: 'link', module:['campaign'], state: "trainers/view" },
      { name: "Trainer", type: 'link', module:['campaign'], state: "trainers/edit" },
      { name: "Trainer", type: 'link', module:['campaign'], state: "trainers/create" },
    ],
    badges: [{ color: "primary", value: "1" }]
  },

  {
    module:['report'],
    name: "Reports",
    type: "link",
    tooltip: "Doctor",
    state: "reports",

    badges: [{ color: "primary", value: "1" }]
  },


  {
    module:['location','role','user','log_activity','company','profession' , 'role_permission'],
    name: "Settings",
    type: "link",
    state: "",
    sub: [
      { name: "Settings", type: 'link', module: ['location'], state: "settings/location" },
      { name: "Settings", type: 'link', module: ['company'], state: "settings/arc-company" },
      { name: "Settings", type: 'link', module: ['profession'], state: "settings/profession" },
      { name: "Settings", type: 'link', module: ['role'], state: "settings/role" },
      { name: "Settings", type: 'link', module: ['user'], state: "settings/users" },
      { name: "Settings", type: 'link', module:['role_permission'], state: "settings/role-permission" },
      { name: "Settings", type: 'link', module: ['log_activity'], state: "settings/activity-log" },
      { name: "Settings", type: 'link', module:['location','role','user','log_activity','company','profession'], state: "settings/change-password" },
    ],
  },


];


